"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.OsmosysHeader = ({ heading = 3, osysName, className, children, }) => {
    return react_1.createElement(`h${heading === 'sm' ? 5 : heading === 'lg' ? 2 : heading}`, {
        className: classnames_1.default(className),
        'data-osmosys-comp': osysName,
        'data-osmosys-comp-base': 'OsmosysHeader',
        'data-osmosys-heading': heading,
    }, children);
};
//# sourceMappingURL=OsmosysHeader.js.map